/**
 * useParagraphs
 * @author @jstarsky
 * @param {*} input
 * @return {Object}
 */
const useParagraphs = ({
  id,
  fontFamily,
  size,
  transform,
  weight,
  italic,
  extendClassname
}) => {
  /**
   * setFontFamily
   * @author @jstarsky
   * @param {String} input
   * @return {String}
   * https://tailwindcss.com/docs/font-family#header
   */
  const setFontFamily = (input) => {
    switch (input) {
      case 'workSans':
        return ' tw-font-workSans'
      case 'gotham':
        return ' tw-font-gotham'
      case 'Trade':
        return ' tw-font-Trade'
      default:
        return ''
    }
  }

  /**
   * setSize
   * @author @jstarsky
   * @param {Numer | String} input
   * @return {String}
   * https://tailwindcss.com/docs/font-size#header
   */
  const setSize = (input) => {
    switch (input) {
      case 'xxxs':
        return ' tw-text-xxxs'
      case 'xxs':
        return ' tw-text-xxs'
      case 'xs':
        return ' tw-text-xs'
      case 'sm':
        return ' tw-text-sm'
      case 'base':
        return ' tw-text-base'
      case 'lg':
        return ' tw-text-lg'
      case 'xl':
        return ' tw-text-xl'
      case '2xl':
        return ' tw-text-2xl'
      case '3xl':
        return ' tw-text-3xl'
      case '4xl':
        return ' tw-text-4xl'
      case '5xl':
        return ' tw-text-5xl'
      case '6xl':
        return ' tw-text-6xl'
      case '7xl':
        return ' tw-text-7xl'
      case '8xl':
        return ' tw-text-8xl'
      case '9xl':
        return ' tw-text-9xl'
      default:
        return ''
    }
  }

  /**
   * setTransform
   * @author @jstarsky
   * @param {String} input transform
   * @return {String}
   * https://tailwindcss.com/docs/text-transform#transforming-text
   */
  const setTransform = (input) => {
    switch (input) {
      case 'uppercase':
        return ' tw-uppercase'
      case 'lowercase':
        return ' tw-lowercase'
      case 'capitalize':
        return ' tw-capitalize'
      default:
        return ''
    }
  }

  /**
   * setWeight
   * @author @jstarsky
   * @param {String} input weight
   * @return {String}
   * https://tailwindcss.com/docs/text-transform#transforming-text
   */
  const setWeight = (input) => {
    switch (input) {
      case 'light':
        return ' tw-font-light'
      case 'medium':
        return ' tw-font-semibold'
      case 'bold':
        return ' tw-font-bold'
      case 'book':
        return ' tw-font-book'
      case 'regular':
        return ' tw-font-regular'
      default:
        return ''
    }
  }

  /**
   * setItalic
   * @author @jstarsky
   * @param {String} input italic
   * @return {String}
   * https://tailwindcss.com/docs/text-transform#transforming-text
   */
  const setItalic = (input) => {
    if (input) return ' tw-italic'
    else return ''
  }

  return {
    internalClassName: `${id}${setFontFamily(fontFamily)}${setSize(
      size
    )}${setTransform(transform)}${setWeight(weight)}${setItalic(italic)}${
      extendClassname ? ` ${extendClassname}` : ''
    }`
  }
}
export default useParagraphs
